<template>
    <div id="about">
        <div class="img">
            <Banner v-if="imgs.length>0" :banner="imgs" />
        </div>
        <div class="box">
            <div class="left">
                <ul>
                    <li v-for="(item,index) in navigationBars" :key="item.id" :class="{active:active===index}">
                        <router-link :to="item.url"><img :src="active===index?green:white" alt=""><span>{{item.title_head}}</span></router-link>
                    </li>
                </ul>
            </div>
            <div class="right">
                <div class="name">
                    <div class="t">
                        <span v-if="active === 0" class="about">关于颐思特</span>
                        <span v-if="active === 1" class="development">发展历程</span>
                        <span v-if="active === 2" class="honor">荣誉资质</span>
                        <span v-if="active === 3" class="cooperation">合作共建</span>
                    </div>
                    <div class="bread">
                        <img src="../../assets/images/icon-address.png" alt="">
                        <router-link to="/">首页</router-link>
                        <span> / {{active===0?'公司简介':active===1?'发展历程':active===2?'荣誉资质':'合作共建'}}</span>
                    </div>
                </div>
                <router-view />
            </div>
        </div>
    </div>
</template>

<script>
    import white from '../../assets/images/icon-right-3.png'
    import green from '../../assets/images/icon-right-2.png'
    import Banner from "../../components/public/Banner";
    export default {
        name: "About",
        components:{Banner},
        data(){
            return{
                white,
                green,
                active:0,
                navigationBars:[],
                imgs:[]
            }
        },
        methods:{
            getNav(){
                this.$axios({
                    url:'/navigation/navigationbar',
                    method:'get'
                }).then(res=>{
                    if (res.data.code === 200){
                        this.navigationBars = res.data.msg.navigationBars[1].navigationSubmenus;
                        this.imgs = res.data.msg.navigationBars[1].navigationImgs;
                    }
                })
            },
            setActive(name){
                switch (name) {
                    case "Introduction":
                        this.active = 0;
                        break;
                    case "Development":
                        this.active = 1;
                        break;
                    case "Honor":
                        this.active = 2;
                        break;
                    case "Cooperation":
                        this.active = 3;
                        break;
                }
            }
        },
        created() {
            const name = this.$route.name;
            this.setActive(name);
            this.getNav();
        },
        computed:{
            getPath(){
                return this.$route.name
            }
        },
        watch:{
            getPath(name){
                this.setActive(name);
            }
        }
    }
</script>

<style scoped lang="less">
#about{
    background-color: #ffffff;
    .img{
        img{
            width: 100%;
        }
    }
    .box{
        width: 1180px;
        margin: 40px auto;
        display: flex;
        .left{
            margin-right: 30px;
            ul{
                background-color: #307C48;
                width: 172px;
                border-radius: 10px;
                padding: 18px 0;
                margin: 0;
                li{
                    list-style: none;
                    height: 48px;
                    line-height: 48px;
                    margin-left: 14px;
                    padding-left: 14px;
                    border-radius:100px 0 0 100px;
                    a{
                        text-decoration: none;
                        img{
                            width: 16px;
                            height: 16px;
                            vertical-align: middle;
                            margin-right: 2px;
                        }
                        span{
                            color: #FFFFFF;
                            font-size: 14px;
                            vertical-align: middle;
                        }
                    }
                }
                .active{
                    background-color: #FFFFFF;
                    a{
                        span{
                            color: #307C48;
                        }
                    }
                }
            }
        }
        .right{
            flex: 1;
            .name{
                display: flex;
                justify-content: space-between;
                padding-bottom: 20px;
                border-bottom: 1px solid #E0E0E0;
                .t{
                    span{
                        color: #181818;
                        font-size: 26px;
                        font-weight: bold;
                        &::after{
                            content: '';
                            color: #999999;
                            font-size: 14px;
                            vertical-align: text-bottom;
                            margin-left: 10px;
                        }
                    }
                    .about{
                        &::after{
                            content: '/ ABOUT US';
                        }
                    }
                    .development{
                        &::after{
                            content: '/ DEVELOPMENT PATH';
                        }
                    }
                    .honor{
                        &::after{
                            content: '/ HONOR';
                        }
                    }
                    .cooperation{
                        &::after{
                            content: '/ COOPERATION AND CONSTRUCTION';
                        }
                    }
                }
                .bread{
                    margin-top: 15px;
                    img{
                        width: 20px;
                        height: 20px;
                        margin-right: 10px;
                        vertical-align: middle;
                    }
                    a{
                        text-decoration: none;
                        color: #307C48;
                        font-size: 14px;
                        vertical-align: middle;
                    }
                    span{
                        font-size: 14px;
                        color: #575757;
                        vertical-align: middle;
                    }
                }
            }
        }
    }
}
</style>
